import { Route, Routes } from 'react-router';
import { Navigate } from 'react-router-dom'
import { PublicLayout } from '@/layouts/public';
import { DocumentSignature } from '@/pages/document-signature/DocumentSignature'
import { DocumentUpload } from '@/pages/document/DocumentUpload'
import { InvoiceView } from '@/pages/billing/invoice/InvoiceView'
import { CrmAuthRedirect } from '@/pages/crm/CrmAuthRedirect' 
import { AttorneyRequest } from '@/pages/Referral/AttorneyRequest' 
import { IntakeFormFill } from '@/pages/intake-form/IntakeFormFill'
import { SharedSpaceView } from '@/pages/shared-space/SharedSpaceView'

const PublicPage = () => {
  // Public layout for external users who dont have access to the system
  // route for this layout -> /public/*
  return (
    <Routes>
      <Route element={<PublicLayout />}>
      {/* <Route path="/secure-form/:id" element={<SecureFormEmbed />} /> */}
        <Route path="/intake-form" element={<IntakeFormFill />} />
        <Route path="/referrals/" element={<AttorneyRequest />} />
        <Route path="/submit-document-signature/:id" element={<DocumentSignature />} />
        <Route path="/upload/:token" element={<DocumentUpload />}/>
        <Route path="/pay-invoice/:token" element={<InvoiceView />} />
        <Route path="/shared/:token" element={<SharedSpaceView />} />
        <Route path="/hubspot/callback/:token" element={<CrmAuthRedirect />} />
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
    </Routes>
  );
}
export { PublicPage };